import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=c82b493c&scoped=true&"
import script from "./TagsList.vue?vue&type=script&lang=js&"
export * from "./TagsList.vue?vue&type=script&lang=js&"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=c82b493c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82b493c",
  null
  
)

export default component.exports